import { useEffect, useState } from 'react';

export function useTimeline(sessionId: string, limit = 60) {
    const [events, setEvents] = useState<any[]>([]);

    useEffect(() => {
        let active = true;
        (async () => {
            const r = await fetch(`/api/agent/${sessionId}/timeline`);
            const j = await r.json();
            if (!active) return;
            const data = (j?.data ?? []).slice(0, limit);
            setEvents(data);
        })();
        return () => {
            active = false;
        };
    }, [sessionId, limit]);

    return events;
}
